module.exports = __webpack_public_path__ + "img/Solutions-in-Action-600x400.4a582bb1.png";